import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: var(--fixit);
  margin-bottom: 8px;
  margin-top: 16px;
  border-bottom: 1px solid var(--light-gray);
  padding-bottom: 8px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FlexInput = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
`;

export const StepDescription = styled.p`
  font-size: 15px;
  color: var(--gray);
  margin-bottom: 8px;
  margin-top: -8px;
`;

export const DeliveryCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--fixit);
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--dark-gray);
  cursor: pointer;
  margin-top: 8px;
  font-weight: 500;
`;

export const BumpCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const DiscountText = styled.span`
  color: #e53935;
  font-weight: 700;
  margin-left: 4px;
`;

/* Order Bump Section */
export const OrderBumpBox = styled.div<{ $selected: boolean }>`
  background-color: ${({ $selected }) => ($selected ? "rgba(152, 53, 209, 0.05)" : "rgba(229, 57, 53, 0.05)")};
  border: 2px dashed ${({ $selected }) => ($selected ? "var(--fixit)" : "#e53935")};
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  transition: all 0.2s ease;
`;

export const BumpHeader = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  
  svg {
    font-size: 28px;
    color: ${({ $selected }) => ($selected ? "var(--fixit)" : "#e53935")};
    transition: color 0.2s ease;
  }
`;

export const BumpTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: var(--black);
  margin: 0;
`;

export const BumpDescription = styled.p`
  font-size: 14px;
  color: var(--dark-gray);
  margin: 0;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`;

export const BumpSelect = styled.select<{ $hasError?: boolean }>`
  width: 100%;
  padding: 14px 16px;
  border: 1px solid ${({ $hasError }) => ($hasError ? "red" : "var(--gray)")};
  border-radius: 8px;
  font-size: 16px;
  color: var(--dark-gray);
  background-color: var(--white);
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;

  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? "red" : "var(--fixit)")};
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-top: 0;
  padding-top: 24px;
  border-top: 1px solid var(--light-gray);

  @media (max-width: 600px) {
    flex-direction: column-reverse;
    gap: 16px;
    
    button {
      width: 100%;
    }
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: 1px solid var(--fixit);
  color: var(--fixit);
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }
`;